// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eb43ac93","455":"c4a9d40e","977":"9cafc8d3"}[chunkId] + ".chunk.js";
};